export const STORAGE_KEYS = {
	AUTH_TOKEN: 'authToken',
	USER: 'user',
	INDEX_TIMESTAMP: 'indexTimestamp',
};
